import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { link_BASE_URL } from '../../utils/constants';
// 
class PrivacyPolicy extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Privacy Policy
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Privacy Policy</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section className="about-section section-padding fix bg-cover">
                    <div className="container">
                        <div className="about-wrapper style-2">
                            <div className="row">
                                <div className="col-lg-12 mt-4 mt-lg-0">
                                    <div className="about-content">
                                        <div className="section-title mb-3 mxw-650">
                                            <div className="subtitle">
                                                <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                <span>Privacy Policy</span>
                                                <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                            </div>
                                            <h2 className="title"> Privacy Policy for Trade Services </h2>
                                        </div>
                                        <p>
                                            If you choose to use our Service, then you agree to the collection
                                            and use of information in relation with this policy. The Personal
                                            Information that we collect are used for providing and improving
                                            the Service of ITME events &amp; activities only
                                        </p>
                                        <p>
                                            India ITME Society may share the data with third party service
                                            providers to enhance the services offered. The information
                                            collected is used only for ITME Society event &amp;
                                            communications. The Society is committed to protecting the private
                                            &amp; confidential of participants.
                                        </p>
                                        <p>
                                            The terms used in this Privacy Policy have the same meanings as in
                                            our Terms and Conditions, which is accessible at{" "}
                                            <a href={`${link_BASE_URL}termsAndCondition`} target='blank'>
                                                {`${link_BASE_URL}termsAndCondition`}
                                            </a>{" "}
                                            unless otherwise defined in this Privacy Policy.
                                        </p>
                                        <h6>Information Collection and Use</h6>
                                        <p>
                                            For a better experience while using our Service, we may require
                                            you to provide us with certain personally identifiable
                                            information, including but not limited to your name, phone number,
                                            and postal address
                                        </p>
                                        <h6>Log Data</h6>
                                        <p>
                                            We want to inform you that whenever you visit our Service, we
                                            collect information that your browser sends to us that is called
                                            Log Data. This Log Data may include information such as your
                                            computer’s Internet Protocol (“IP”) address, browser version,
                                            pages of our Service that you visit, the time and date of your
                                            visit, the time spent on those pages, and other statistics.
                                        </p>
                                        <h6>Cookies</h6>
                                        <p>
                                            Cookies are files with small amount of data that is commonly used
                                            an anonymous unique identifier. These are sent to your browser
                                            from the website that you visit and are stored on your computer’s
                                            hard drive. Our website uses these “cookies” to collection
                                            information and to improve our Service. You have the option to
                                            either accept or refuse these cookies and know when a cookie is
                                            being sent to your computer. If you choose to refuse our cookies,
                                            you may not be able to use some portions of our Service.
                                        </p>
                                        <h6>Service Providers</h6>
                                        <p>
                                            We may employ third-party companies and individuals due to the
                                            following reasons: To facilitate our Service; To provide the
                                            Service on our behalf; To perform Service-related services; or to
                                            assist us in analysing how our Service is used. We want to inform
                                            our Service users that these third parties have access to your
                                            Personal Information. The reason is to perform the tasks assigned
                                            to them on our behalf. However, they are obligated not to disclose
                                            or use the information for any other purpose.
                                        </p>
                                        <h6>Security</h6>
                                        <p>
                                            We value your trust in providing us your Personal Information,
                                            thus we are striving to use commercially acceptable means of
                                            protecting it. But remember that no method of transmission over
                                            the internet, or method of electronic storage is 100% secure and
                                            reliable, and we cannot guarantee its absolute security.
                                        </p>
                                        <h6>Links to Other Sites</h6>
                                        <p>
                                            Our Service may contain links to other sites. If you click on a
                                            third-party link, you will be directed to that site. Note that
                                            these external sites are not operated by us. Therefore, we
                                            strongly advise you to review the Privacy Policy of these
                                            websites. We have no control over, and assume no responsibility
                                            for the content, privacy policies, or practices of any third-party
                                            sites or services.
                                        </p>
                                        <h6>Children’s Privacy</h6>
                                        <p>
                                            Our Services do not address anyone under the age of 15. We do not
                                            knowingly collect personal identifiable information from children
                                            under 15. In the case we discover that a child under 15 has
                                            provided us with personal information, we immediately delete this
                                            from our servers. If you are a parent or guardian and you are
                                            aware that your child has provided us with personal information,
                                            please contact us so that we will be able to do necessary actions.
                                        </p>
                                        <h6>Changes to This Privacy Policy</h6>
                                        <p>
                                            We may update our Privacy Policy from time to time. Thus, we
                                            advise you to review this page periodically for any changes. We
                                            will notify you of any changes by posting the new Privacy Policy
                                            on this page. These changes are effective immediately, after they
                                            are posted on this page.
                                        </p>
                                        <h6>Contact Us</h6>
                                        <p>
                                            If you have any questions or suggestions about our Privacy Policy,
                                            do not hesitate to contact us.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(PrivacyPolicy));